import { render } from "./claimantList.vue?vue&type=template&id=1bf51fb9"
import script from "./claimantList.vue?vue&type=script&lang=js"
export * from "./claimantList.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__